import { LOCAL_CONFIG } from './config';

const serverPrefix = LOCAL_CONFIG.server;

export default {
  common: {
    getMenu: serverPrefix + '/admin/menu',
    queryHouseList: serverPrefix + '/zhfc/portal/buildingInfo',
    dictItemsByType: serverPrefix + '/admin/dict/item/tree',
    getContractInfoById: serverPrefix + '/zhfc/portal/getContractInfoById',
    getUserInfo: serverPrefix + '/admin/user/info',
    getTrustUrl: serverPrefix + '/admin/gft/gettrusturl',
  },
  login: {
    getCode: serverPrefix + '/code',
    checkCode: serverPrefix + '/code/check',
    login: serverPrefix + '/auth/oauth/token',
  },
  zhfc: {
    contractInfo: serverPrefix + '/zhfc/portal/contractInfo',
    getEnterpriseData: serverPrefix + '/zhfc/portal/getEnterpriseData',
    getXmysxkzData: serverPrefix + '/zhfc/portal/getXmysxkzData',
    getProjectData: serverPrefix + '/zhfc/portal/getProjectData',
  },
  newHouse: {
    syncUser: serverPrefix + '/zhfc/third/token',
    todoList: serverPrefix + '/zhfc/xfgzyjs/dbsxlb',
    myContractList: serverPrefix + '/zhfc/xfgzyjs/grhtlb',
    createBusiness: serverPrefix + '/zhfc/xfgzyjs/ywcj',
    updateBusiness: serverPrefix + '/zhfc/xfgzyjs/ywgx',
    businessDetail: serverPrefix + '/zhfc/xfgzyjs/ywxq',
    myBusinessList: serverPrefix + '/zhfc/xfgzyjs/grywlb',
    maintenanceFund: serverPrefix + '/zhfc/xfgzyjs/wxzjjk',
    uploadFile: serverPrefix + '/zhfc/file/uploadFile',
    downloadFile: serverPrefix + '/zhfc/file/downloadFile',
    removeFile: serverPrefix + '/zhfc/file/rm',
  },
};
